/* Ability Warehouse — right-hand slide-out cart with add-to-cart without leaving the page */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-cart-drawer]');
  if (!wrap) return;
  var panel = wrap.querySelector('.cd__panel');
  var lastFocus = null;
  var SECTION = '/cart?section_id=cart-drawer';

  function inner() { return wrap.querySelector('[data-cd-inner]'); }
  function setCount(n) {
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.header__count');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'header__count'; a.appendChild(c); }
        c.textContent = n;
        c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      } else if (c) c.remove();
    });
  }
  function msg(text, type) {
    var m = wrap.querySelector('[data-cd-msg]');
    if (!m) return;
    m.className = 'cd__msg' + (type ? ' cd__msg--' + type : '');
    m.innerHTML = text || '';
  }
  function refresh() {
    return fetch(SECTION, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cd-inner]');
      if (fresh) {
        inner().replaceWith(fresh);
        setCount(parseInt(fresh.dataset.count, 10) || 0);
      }
    });
  }
  function open() {
    lastFocus = document.activeElement;
    wrap.hidden = false;
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    document.body.classList.add('no-scroll');
    setTimeout(function () { panel.focus(); }, 50);
  }
  function close() {
    wrap.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { wrap.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.CWCart = { open: function () { refresh().then(open); }, refresh: refresh };

  /* Open from the header cart button (the cart page itself keeps the normal link) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.header__cart, [data-cart-open]');
    if (a && !/^\/cart\/?$/.test(location.pathname)) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var q = e.target.closest('[data-cd-qty]');
    if (q) change(q.dataset.cdQty, parseInt(q.dataset.q, 10));
  });
  wrap.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cd-input]');
    if (i) change(i.dataset.cdInput, Math.max(0, parseInt(i.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap.classList.contains('is-open')) close();
    if (e.key === 'Tab' && wrap.classList.contains('is-open')) {
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function change(line, qty) {
    wrap.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return refresh().then(function () { if (!res.ok) msg(res.j.description || res.j.message || 'Could not update that line.', 'error'); });
      })
      .catch(function () { msg('Could not update your cart. Please try again.', 'error'); })
      .then(function () { wrap.classList.remove('is-busy'); });
  }

  /* Intercept every add-to-cart form on the site */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1 || form.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    var stickyBtn = document.querySelector('[data-sb-add]');
    if (stickyBtn) stickyBtn.classList.add('is-loading');
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return refresh().then(function () {
          if (res.ok) {
            var qty = parseInt(fd.get('quantity'), 10) || 1;
            var name = res.j.product_title || 'Item';
            msg('<span class="cd__tick" aria-hidden="true">✓</span> Added ' + (qty > 1 ? qty + ' × ' : '') + name.replace(/</g, '&lt;'), 'ok');
          } else {
            msg(res.j.description || res.j.message || 'Sorry, that could not be added.', 'error');
          }
          open();
        });
      })
      .catch(function () { form.setAttribute('data-no-drawer', ''); form.submit(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; }
        if (stickyBtn) stickyBtn.classList.remove('is-loading');
      });
  });
})();
